import { schemes } from "@zeal/common";
import { z } from "zod";

export const requestWorkerPaycardsRequestSchema = z.object({
  cardholder_agreement: z.boolean(),
  esign_disclosure: z.boolean(),
  deposit_agreement: z.boolean(),
  patriot_act: z.boolean(),
  privacy_policy: z.boolean(),
  terms_and_conditions: z.boolean(),
  tisa_account_disclosure: z.boolean(),
  signature: z.string(),
  workerId: schemes.mongoObjectId(),
});

export type TRequestWorkerPaycardsRequest = z.infer<
  typeof requestWorkerPaycardsRequestSchema
>;
